import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import GhxpCountdown from "./GhxpCountdown";
import { CtaButton, EventInfo, Photo, SceneStage, ScrollHint, Signature, Tagline } from "./GhxpUi";
import { HERO } from "./ghxpAssets";
import logoGhExperience from "../../../assets/img/ghExperience/logo-ghexperience.svg";

// Abertura: o convite digital aprovado sobre o rooftop da Experience House na hora azul (vídeo de ponta a ponta).
// A mídia vive num "palco" que inclina levemente com o mouse, com uma luz que segue o cursor e a seta
// da marca se desenhando; no celular o palco deriva devagar. O vídeo começa a baixar durante o convite
// fechado e só toca quando o slide assenta; o pôster fica por baixo até o primeiro quadro.
function GhxpOpening({ countdown, onStart, onNext, showHint, active, settled, lowPower, portrait }) {
  const { t } = useTranslation();
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return undefined;
    if (active && settled) {
      video.play().catch(() => {});
      return undefined;
    }
    video.pause();
    if (!active) {
      const timer = window.setTimeout(() => {
        video.currentTime = 0;
        setPlaying(false);
      }, 900);
      return () => window.clearTimeout(timer);
    }
    return undefined;
  }, [active, settled, portrait]);

  useEffect(() => {
    const onVisibility = () => {
      const video = videoRef.current;
      if (!video) return;
      if (document.hidden) video.pause();
      else if (active && settled) video.play().catch(() => {});
    };
    document.addEventListener("visibilitychange", onVisibility);
    return () => document.removeEventListener("visibilitychange", onVisibility);
  }, [active, settled]);

  return (
    <>
      <SceneStage shade="hero" className="ghxpOpening__stage">
        <Photo photo={HERO.poster} alt="" priority sizes="100vw" />
        {!lowPower && (
          <video
            ref={videoRef}
            key={portrait ? "tall" : "wide"}
            className={`ghxpStage__video ${playing ? "is-playing" : ""}`}
            src={portrait ? HERO.videoTall : HERO.video}
            muted
            loop
            playsInline
            preload="auto"
            onPlaying={() => setPlaying(true)}
          />
        )}
      </SceneStage>

      <div className="ghxpOpening__panel ghxpDepth" data-scrollable="y">
        <h1 className="ghxpOpening__logo ghxpReveal">
          <img src={logoGhExperience} alt="#GHEXPERIENCE" width="912" height="83" />
        </h1>
        <Tagline className="ghxpReveal" />
        <p className="ghxpOpening__text ghxpReveal">{t("ghxp_invite_text")}</p>
        <EventInfo className="ghxpReveal" />
        <div className="ghxpOpening__actions ghxpReveal">
          <CtaButton onClick={onStart}>{t("ghxp_cta")}</CtaButton>
        </div>
        <GhxpCountdown countdown={countdown} className="ghxpOpening__countdown ghxpReveal" />
        <Signature className="ghxpOpening__signature ghxpReveal" />
      </div>

      <ScrollHint
        label={t("ghxp_scroll_hint")}
        onClick={onNext}
        className={`ghxpOpening__hint ${showHint ? "" : "is-hidden"}`}
      />
    </>
  );
}

export default GhxpOpening;
